module.exports = __webpack_public_path__ + "836863ffdc9d12907233e8ca563e6379.MP3";